/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */
import OcrConfirmation from 'vcomponents/ocr/OcrConfirmation.vue';
export default [
    {
        path: '/ocr/list/:linkedtype',
        name: "ocr.list",
        meta: {
            menuId: 'purchases'
        }
    },
    {
        path: '/ocr/verification/:id',
        name: "ocr.verification.form",
        meta: {
            menuId: 'purchases'
        }
    },
    {
        path: '/rest/ocr/create/:linkedtype',
        name: 'legacy.ocr.create'
    },
    {
        path: '/ocr/confirmation',
        name: 'ocr.confirmation',
        component: OcrConfirmation,
        props: true
    }
]